export default __webpack_public_path__ + "8690a3af60a2106e182734828996a1ce.png";